import { EmbroideryConfig } from '../../types/graphql'

import { embroideryVariant } from './unorganized'

export const embroideryConfig: EmbroideryConfig = {
  image: 'https://cdn.shopify.com/s/files/1/0298/0967/2276/products/EMB-icon.png?v=1609982382',
  logoName: 'Laserway Logo',
  mandatoryLogoEmbroidery: false,
  noText: 'No',
  questionText: 'Do you want to add embroidery?',
  variant: embroideryVariant,
  yesText: 'Yes',
  quickBuyText: 'Quick Buy Text',
}
